import * as CountryCodeByLocales from '@/assets/data/country_codes_by_locales.json';

import useLocalStorage from '@/composables/storage/useLocalStorage';

interface LocaleEntry {
  country: string;
  en_name: string;
  native_name: string;
  locales: string[];
  mappedCurrency: string;
}

const { checkLocalStorage } = useLocalStorage();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const localeData = (CountryCodeByLocales as any).default as LocaleEntry[];

const currencyFromCountry = (countryCode: string): string => {
  const locale = localeData.find((loc) => loc.country === countryCode);

  if (!locale) {
    throw new Error(`Country code ${countryCode} not found in country_codes_by_locales`);
  }

  return locale.mappedCurrency;
};

const countryFromCurrency = (
  currencyCode: string,
): string | undefined => Object.keys(localeData).find(
  (countryCode) => {
    const data = localeData as unknown as Record<string, LocaleEntry>;
    return data[countryCode].mappedCurrency === currencyCode;
  },
);

const fetchCurrencyFromStorage = (): string => {
  const currency = checkLocalStorage('global');
  const defaultFiat = currency?.defaultFiat;
  return defaultFiat || 'USD';
};

export { currencyFromCountry, countryFromCurrency, fetchCurrencyFromStorage };
